import React, {useEffect, useState} from 'react';
import Header from "../navigation/Header";
import {changeAgreementPlan, changeAgreementPlanInfo} from "../../services/ProductRepository";
import {Link, useParams} from "react-router-dom";
import {useError} from "../../hooks/useError";

function getAlertOnChange(status, positiveMsg, negativeMsg) {
    if(status) {
        return (
            <div className={"alert alert-primary"} role="alert">
                <p>{positiveMsg}</p>
            </div>
        );
    } else {
        return (
            <div className={"alert alert-danger"} role="alert">
                <p>{negativeMsg}</p>
            </div>
        );
    }
}

export function SubscriptionSwitchConfirmation() {

    const [info, setInfo] = useState(null);
    const [changeStatus, setChangeStatus] = useState(null);

    const params = useParams();
    const {setErrorMessage} = useError();

    useEffect(() => {
        changeAgreementPlanInfo(params.oldTokenId, params.newTokenId, setErrorMessage)
            .then(response => setInfo(response))
    }, []);

    if(info == null) {
        return null;
    }

    return (
        <div>
            <Header/>

            <div className={"container p-5"}>


                <h2>Bytting av abonnement</h2>

                <div className={"border border-2 rounded p-3"}>
                    <p className={"text-muted m-0"}>Betal nå</p>
                    <h3 className={"m-0"}>{info.charge.price} NOK</h3>
                </div>

                <div className={"border border-2 rounded p-3 my-2"}>
                    <p className={"text-muted m-0"}>Betalingsmåte</p>
                    <h3 className={"m-0"}>VIPPS</h3>
                </div>

                <p>{info.message}</p>


                <h4 className={"mt-2"}>Oppsummering</h4>
                <table className={"table "}>
                    <thead>
                    <tr>
                        <th>Beløp</th>
                        <th>Beskrivelse</th>
                        <th>Når</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{info.charge.price}</td>
                        <td>{info.charge.description}</td>
                        <td>{info.charge.date}</td>
                    </tr>
                    <tr>
                        <td>{info.renewalCharge.price}</td>
                        <td>{info.renewalCharge.description}</td>
                        <td>{info.renewalCharge.date}</td>
                    </tr>
                    </tbody>
                </table>

                <p className={"m-0"}><strong>Total:</strong> {info.charge.price} NOK</p>

                {
                    changeStatus != null ?
                        getAlertOnChange(changeStatus, "Din plan har blitt oppdatert!", "Beklager, noe gikk galt under endringen av pakken din.")
                        : null
                }

                <Link to={`/purchase/${params.newTokenId}`} className={"btn btn-success text-white py-3 mt-3 w-100 "+ (changeStatus === true ? "disabled": "")}  data-testid={"bekreft-bytting"}>

                    {
                        info.charge.price === 0 ? "Bytt til denne pakken" : "Betal nå og oppgrader"
                    }

                </Link>
            </div>
        </div>
    );
}